export const userManagement = {
  enumController: {
    getEnumData: '/enums',
    getEnumDataFromCode: '/enums/',
    saveEnumData: '/enums/enums',
    updateEnumData: '/enums/enums/',
  },
  loginController: {
    login: '/login',
    logout: '/logout',
    saveMerchant: '/registerMerchant',
    ssoLogin: '/ssologin',
  },
  permissionController: {
    getPermissions: '/permissions',
  },
  roleController: {
    getRoles: '/roles',
    addRole: '/roles',
    findRoleById: '/roles/',
    updateRole: '/roles/',
    deleteRole: '/roles/',
  },
  userController: {
    addUser: '/users',
    findUserById: '/users/',
    updateUser: '/users/',
    deleteUser: '/users/',
    getUsers: '/users/',
    findUsersByCategory: '/users/findUsersByCategory',
    forgotPassword: '/users/forgotPassword',
    resetPassword: '/users/resetPassword',
    uploadUsers: '/users/upload',
    findUsername: '/users/username/',
  },
};

export const spotFinder = {
  
  labourController:{
    findAllLabourDetails:'/labour/findAll', //findAllLabourDetail
    getLabourDetailById:'/labour/findById/', //findLabourDetailById
    getAllLabourDetail:'/labour/findAllWithPagination',  //getAllLabourDetails
    updateLabourDetail:'/labour/update',
    saveLabourDetail:'/labour/save',
    deleteLabourDetailById:'/labour/delete/',
    findAvailableLabourDetail:'/labour/getAvailableLabour',
    findLabourDetailByUserId:'/labour/findByUserId',
  },

  addressDetailController:{
    deleteAddressDetail:'/address/delete/',  
    findAllAddressDetail:'/address/findAll',  
    findAddressDetailById:'/address/findById/',   
    saveAddressDetail:'/address/save',
    updateAddressDetail:'/address/update ', 
  },

  labourServiceDetailController:{
    getLabourServiceDetailById:'/api/labour-service-details/findById/',
    getAllLabourServiceDetails:'/api/labour-service-details/',
    createLabourServiceDetail:'/api/labour-service-details/save',
    updateLabourServiceDetail:'/api/labour-service-details/update/',
  },

  labourReferenceController:{
    getLabourReferenceById:'/api/labour-references/findById/',
    getAllLabourReferences:'/api/labour-references/getAll',
    createLabourReference:'/api/labour-references/save',
    getAllLabourReferencesByLabourId:'/api/labour-references/getAllReferencesByLabourId/',
    updateLabourReference:'/api/labour-references/update/',
    deleteReferences:'/api/labour-references/delete/',
  },

  labourOfficialWorkController:{
    getAllLabourOfficialWorks :'/labour-official-work/findALl',
    getLabourOfficialWorkById:'/labour-official-work/findById/',
    createLabourOfficialWork:'/labour-official-work/save',
    updateLabourOfficialWork:'/labour-official-work/update/',
  },

  labourUploadDocController:{
    deleteById:'/labourDocument/',
    getLabourDocumentsDetailsByLabourId:'/labourDocument/',
    saveLabourDocumentDetail:'/labourDocument/save',
    updateLabourDocumentDetail:'/labourDocument/update',
    uploadLabourDocument:'/labourDocument/uploadLaborDocument',
  },

  miscellaneousController:{
    deleteMiscellaneousCharge:'/miscellaneous-charge/delete',
    findMiscellaneousChargesByBookingId:'/miscellaneous-charge/findByBookingId',
    findMiscellaneousChargeById:'/miscellaneous-charge/findById',
    findMiscellaneousChargesByLabourId:'/miscellaneous-charge/findByLabourId',
    getMiscellaneousByLabourAndBooking:'/miscellaneous-charge/miscellaneous',
    saveMiscellaneousCharge:'/miscellaneous-charge/save', 
    updateMiscellaneousCharge:'/miscellaneous-charge/update',
  },

  parkingSlotController: {
    findAllServiceDetail: '/parkingSlot/findAll',
    findParkingSlotById: '/parkingSlot/findById/',
    getParkingsOnSearch: '/parkingSlot/getAllParkingSlotBySearchCriteria',
    saveParkingSlot: '/parkingSlot/save',
    updateParkingSlot: '/parkingSlot/update',
    updateParkingSlotStatus: '/parkingSlot/updateStatus/',
  },
  parkingSpaceLocationController: {
    findAllServiceDetail: '/parkingSpaceLocation/findAll',
    findParkingSpaceLocationById: '/parkingSpaceLocation/findById/',
    getAllParkingSpaceLocation: '/parkingSpaceLocation/getAllParkingSpaceLocationBySearchCriteria',
    saveParkingSpaceLocation: '/parkingSpaceLocation/save',
    updateParkingSpaceLocation: '/parkingSpaceLocation/update',
    deleteParkingSpaceLocationById: '/parkingSpaceLocation/delete/',
  },
  serviceProviderDetailController: {
    createBooking: '/serviceProviderDetail/createBooking',
    getAllServiceProviderDetail: '/serviceProviderDetail/findAll/',
    findServiceProviderDetailById: '/serviceProviderDetail/findById/',
    findServiceProviderDetailByUserId: '/serviceProviderDetail/findByUserId/',
    saveServiceProviderDetail: '/serviceProviderDetail/save',
    updateServiceProviderDetail: '/serviceProviderDetail/update',
    deleteServiceProviderDetail: '/serviceProviderDetail/delete/',
    uploadForm: '/serviceProviderDetail/uploadForm',
    sendStripeOnboardEmail: '/serviceProviderDetail/sendStripeOnboardEmail/',
    updatePayment: '/serviceProviderDetail/updatePayment'

  },
  bookingDetailController: {
    approveCancelBookingByAdmin: '/bookingDetail/approveCancelBookingByAdmin/',
    approveCancelBookingByServiceProvider: '/bookingDetail/approveCancelBookingByServiceProvider/',
    findByBookingId: '/bookingDetail/findByBookingId/',
    getAllBookingDetailBySearchCriteria: '/bookingDetail/getAllBookingDetailBySearchCriteria',
    saveBookingDetail: '/bookingDetail/save',
    updateBookingDetail: '/bookingDetail/update',
    updateActualTime: '/bookingDetail/updateActualTime',
    resolveDispute: '/bookingDetail/resolveDispute',
    completeBookingDetail:'/bookingDetail/complete',


  },

  labourBookingController:{
    lineupLabourWithBooking:'/labour-booking/labour-booking-mapping',
    updateBookingStatusByLabour:'/labour-booking',
  },

  accountDetailController: {
    getAllAccountDetail: '/accontDetail/findAll/',
    findAccountDetailByServiceProvider: '/accountDetail/findByServiceProviderId/',
    saveAccountDetail: '/accountDetail/save',
    updateAccountDetail: '/accountDetail/update',
  },

  serviceProviderFeedbackController: {
    getAllServiceProviderFeedback: '/serviceProviderFeedback/findAllWithPagination',
    findServiceProviderFeedbackById: '/serviceProviderFeedback/findById/',
    findServiceProviderDetailByUserId: '/serviceProviderFeedback/findByUserId/',
    saveServiceProviderFeedback: '/serviceProviderFeedback/save',
    updateServiceProviderFeedback: '/serviceProviderFeedback/update',
  },

  customerFeedbackController:{
    findAllCustomerFeedback:'/customerFeedback/findAll',
    deleteCustomerFeedback:'/customerFeedback/delete',
    getAllCustomerFeedback:'/customerFeedback/findAllWithPagination',
    findCustomerFeedbackByBookingId:'/customerFeedback/findByBookingId',
    findCustomerFeedbackById:'/customerFeedback/findById',
    saveCustomerFeedback:'/customerFeedback/save',
    updateCustomerFeedback:'/customerFeedback/update',
  },

  customerDetailController: {
    getAllCustomerDetail: '/customer/findAllWithPagination/',
    deleteCustomerDetail: '/customer/delete/',
    saveCustomerDetail: '/customer/save',
    updateCustomerDetail: '/customer/update',
    uploadCustomerImage: '/customer/',
    findCustomerDetailById: '/customer/findById/',
  },
  contactSupportController: {
    addQueryContact: '/contactSupport/addQueryContact',
    deleteQueryContact: '/contactSupport/deleteQueryContact/',
    findAllQueryContact: '/contactSupport/findAllQueryContact',
  },
  cityController: {
    addCityData: '/cityData/save',
    deleteCityData: '/cityData/delete',
    getAllCities: '/cityData/getAllCities',
    getcityData: '/cityData/getCityData',
    updateCityData: '/cityData/update',
    uploadCityImage: '/cityData/uploadCityImage',
  },

  countryController: {
    getAllContries: '/countryData/getAllCountries',
  },

  BlogController: {
    saveBlogDetail: '/blogs/save',
    deleteBlogDetail: '/blogs/delete/',
    findBlogBySearch: '/blogs/search',
    updateBlogDetail: '/blogs/update',
    uploadImage: '/blogs/uploadImage',
  },


  POSDeviceDataController: {
    deleteDeviceData: '/posDeviceData/delete/',
    getAllDeviceData: '/posDeviceData/findAll',
    saveDeviceData: '/posDeviceData/save',
    updateDeviceData: '/posDeviceData/update',

  },

  parkingTypeController: {
    deleteParkingType: '/parkingType/delete',
    getParkingTypeData: '/parkingType/getData',
    saveParkingType: '/parkingType/save',
    updateParkingType: '/parkingType/update',
    uploadImage: '/parkingType/uploadImage',
  },
  customerBalanceController: {
    findAll: '/customerBalance/findAll',
  },

  NotesController: {
    saveNotesDetails: '/notes/save',
    findByUserId: '/notes/findByUserId',
  },
  offerDetailController: {
    deleteOfferDetail: '/coinOfferDetail/',
    getAllOfferDetail: '/coinOfferDetail/findAll',
    findOfferDetailById: '/coinOfferDetail/findById/',
    saveOfferDetail: '/coinOfferDetail/save',
    updateOfferDetail: '/coinOfferDetail/update',
    uploadOfferImage:'/coinOfferDetail/uploadCityImage',

  },
  revenueController: {
    getRevenueData: '/invoiceDetail/getRevenueData',
    saveInvoiceDetail: '/invoiceDetail/save',
    updateInvoiceDetail: '/invoiceDetail/update',
    getRevenueDataByParking: '/invoiceDetail/getRevenueDataByParking',
    payToVendor: '/invoiceDetail/payVendor',
  },
  dashboardController: {
    findCount: '/dashboard/',
    getAdminDashboardData: '/dashboard/adminCountData',
    getServiceProviderData: '/dashboard/discovery/',
    getVendorDashboardData: '/dashboard/vendorCountData',
  },
  ParkingSpaceLocationDocumentController: {
    deleteParkingSpaceLocationImage: '/parkingSpaceLocationDoc/delete',
    findByParkingLocationId: '/parkingSpaceLocationDoc/findByParkingLocationId/',
    updateParkingSpaceLocationImage: '/parkingSpaceLocationDoc/update',
    uploadParkingSpaceLocationImage: '/parkingSpaceLocationDoc/upload/',
  },

  HoursOfOperationController: {
    findByParkingLocationId: '/operationalHours/findByParkingLocationId/',
    save: '/operationalHours/save',
    update: '/operationalHours/update',
  },

  StripeController: {
    refund: '/payment/refund',
    createTransfer: '/payment/transfer',
  },

  BlackoutDateController: {
    saveBlackoutDate: '/blackoutDate/save',
    getBlackoutDates: '/blackoutDate/findByParkingId/',
    updateBlackoutDate: '/blackoutDate/update',
  },
  RevenueExcelExportReportController: {
    exportToExcel: '/revenueExportExcel/exportReportData/',
  },

  calculateBillingRateController: {
    calculateBillingRate: "/calculateBillingRate",
    calculateExtraBilling: "/calculateExtraBilling"
  },
  parkingCategoryController: {
    deleteParkingCategoryDetail: '/parkingCategory/delete',
    getParkingCategoryDetail: '/parkingCategory/get',
    getParkingCategoryById: '/parkingCategory/get',
    saveParkingCategoryDetail: '/parkingCategory/save',
    updateParkingCategoryDetail: '/parkingCategory/update',
  },
  VehicleCategoryController: {
    getCategoryList: '/vehicle/category',
    getSubCategoryList: '/vehicle/subCategory/',
  },
  VehicleDetailsController:{
    saveVehicleDetails: '/vehicle/save',
    updateVehicleDetails: '/vehicle/update'
  },
  ServiceProviderDocumentController: {
    findByParkingLocationId: '/serviceProviderId/findByServiceProviderId/',
    updateServiceProviderDoc: '/serviceProviderId/update/',
    uploadServiceProviderDoc: '/serviceProviderId/upload/',
    deleteServiceProviderDoc: '/serviceProviderId/delete/'
  },
  SubBookingDetailController: {
    getCheckInDetails: '/subBookingDetail/getCheckInDetails/',
  },
  PaymentMethodController: {
    deletePaymentMethod: '/paymentMethod/delete/',
    savePaymentMethod: '/paymentMethod/save',
    updatePaymentMethod: '/paymentMethod/update',
    getAllPaymentMethod: '/paymentMethod/getAllPaymentMethod',
    uploadPaymentMethodImage: '/paymentMethod/uploadPaymentMethodImage/'
  },

  posController: {
    cancelPayment: '/pos/cancelPayment',
    checkStatus: '/pos/checkStatus',
    startPayment: '/pos/startPayment'
  }
};
